/**
 * Decodes a JWT token encoded as a base64 string.
 * @param token The base64 string.
 */
export const decodeJwt = (token) => {
    if (token === undefined)
        return undefined;
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
    // Supports base64 encoded UTF-8 strings, see Decoding base64 ⇢ UTF-8
    // from the accepted answer in https://stackoverflow.com/a/30106551
    window.atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    return JSON.parse(jsonPayload);
};
/**
 * Gets the expiration date from a decoded (see <code>decodeJwt</code>) JWT token.
 * @param token The decoded JWT token.
 */
export const getExpirationDate = (token) => {
    return token?.exp !== undefined ? new Date(token.exp * 1000) : undefined;
};
/**
 * Determines whether a JWT is expired or not, with some margin seconds. This is, the token counts
 * is considered as expired if it expires before <code>marginSeconds</code> from now.
 *
 * @param token The JWT token to check.
 * @param marginSeconds The amount of seconds the token must be alive for.
 */
export const isTokenExpired = (token, marginSeconds) => token?.exp !== undefined
    ? (token.exp - marginSeconds) * 1000 < new Date().getTime()
    : true;
//# sourceMappingURL=jwt.js.map